export default __webpack_public_path__ + "static/media/bet3.c2c8cfec.png";